import { MantineProvider } from '@mantine/core'
import { Provider } from 'react-redux';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/carousel/styles.css';
import Route from './mainRouter';
import store from './store';
// import '@mantine/styles.css';

function App() {
    return (
        <>
            <MantineProvider withGlobalStyles withNormalizeCSS>
                <Provider store={store}>
                    <Route />
                </Provider>
            </MantineProvider>
        </>
    )
}

export default App